import type React from "react";
import { cn } from "../utils/cn";

interface ChartIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  title?: string;
  dark?: boolean;
}

export function ChartIcon({ className, title = "Chart Icon", dark, ...props }: ChartIconProps) {
  // Ensure title is never empty for accessibility
  const accessibleTitle = title || "Chart Icon";

  return (
    <svg
      className={cn(className)}
      aria-label={accessibleTitle}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{accessibleTitle}</title>
      <path d="M16.8588 16.001V0H14.8822L14.8822 16.001H16.8588Z" fill={dark ? "white" : "black"} />
      <path d="M8.86005 4.00021V16.001H6.88343L6.88343 4.00021H8.86005Z" fill={dark ? "white" : "black"} />
      <path d="M4.8639 9.00054V16.001H2.88727V9.00054H4.8639Z" fill={dark ? "white" : "black"} />
      <path d="M17.8711 19.9886H1.87109V18.012H17.8711V19.9886Z" fill={dark ? "white" : "black"} />
      <path d="M12.8594 16.001V9.00054H10.8828V16.001H12.8594Z" fill={dark ? "white" : "black"} />
    </svg>
  );
}

export default ChartIcon;
